import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'activity-log-file',
  templateUrl: './activity-log-file.component.html',
  styleUrls: ['./activity-log-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityLogFileComponent implements OnInit, OnDestroy {
  screenWidth: number;
  fileFolderName;
  showTemplte: boolean = true;
  loaderItems = [1, 2, 3];
  activiyLogList = [];
  subscription: Subscription = new Subscription();
  resizeObservable$: Observable<Event>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ActivityLogFileComponent>
  ) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.fileFolderName = this.data?.fileFolderName;

    if (this.data?.isFile) {
      this.showFileHistory();
    } else {
      this.showFolderHistory();
    }
  }

  showFolderHistory() {
    this.subscription.add(
      this.documentService.getFolderActivityLog(this.data?.Id).subscribe((res) => {
        this.activiyLogList = res?.data;
        this.showTemplte = false;
        this.cd.detectChanges();
      })
    );
  }

  showFileHistory() {
    this.subscription.add(
      this.documentService.getFileActivityLog(this.data?.Id).subscribe((res) => {
        this.activiyLogList = res?.data;
        this.showTemplte = false;
        this.cd.detectChanges();
      })
    );
  }

  closedialog() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
